// Tabs/SpecialSessionsTabContent.tsx
import { useState } from 'react';
import { Tabs } from '@mantine/core';
import { IconForms, IconClipboardList } from '@tabler/icons-react';
import { SpecialSessionFormFiller } from './SpecialSessionFormFiller';
import { SpecialSessionAnswersTab } from './SpecialSessionAnswersTab';
import { useParticipantMemberOptions } from './useParticipantMemberOptions';

export interface SpecialSessionsTabContentProps {
  registrationID: number;
  registrationSessionID: number;
}

export default function SpecialSessionsTabContent({
  registrationID,
  registrationSessionID,
}: SpecialSessionsTabContentProps) {
  // Loaded once here so the filler and the answers table share one fetch.
  const memberOptions = useParticipantMemberOptions(registrationID);
  const [view, setView] = useState<'fill' | 'answers'>('fill');
  const [answersKey, setAnswersKey] = useState(0); // bump to force a remount+refetch

  return (
    <Tabs
      value={view}
      onChange={(v) => setView((v as typeof view) ?? 'fill')}
      keepMounted={false} // ← panels only mount when active, so Answers always fetches fresh
    >
      <Tabs.List mb="md">
        <Tabs.Tab value="fill" leftSection={<IconForms size={16} />}>Fill Form</Tabs.Tab>
        <Tabs.Tab value="answers" leftSection={<IconClipboardList size={16} />}>Questions & Answers</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="fill">
        <SpecialSessionFormFiller
          registrationSessionID={registrationSessionID}
          memberOptions={memberOptions}
          onSubmitted={() => {
            setAnswersKey((k) => k + 1);
            setView('answers');
          }}
        />
      </Tabs.Panel>

      <Tabs.Panel value="answers">
        <SpecialSessionAnswersTab
          key={answersKey}
          registrationSessionID={registrationSessionID}
          memberOptions={memberOptions}
        />
      </Tabs.Panel>
    </Tabs>
  );
}